import "@norstella/coverage-finder/dist/coverage-finder";
import "@sm2dev/sobi-doptelet-coverage-finder/dist/style.css";

function App() {
  return (
    <div className="coverage-finder-wrapper">
      <coverage-finder
        id="coverageFinder"
        token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwcm9kdWN0cyI6Ilt7XCJQcm9kdWN0SWRcIjpcIjIzNDA4MVwiLFwiTmFtZVwiOlwiRG9wdGVsZXQgKDEwIHRhYiBwYWNrKSAyMCBtZyB0YWJsZXRcIn1dIiwiY2xpZW50SWQiOiIxMzI0NiIsInVzZXJOYW1lIjoiZzIrN1ZSRWpvZlBaUFpZQzNVV1dQUGEyZGNjYmJId0hLNTVFMVVMUXFLaz0iLCJwYXNzd29yZCI6ImppaG5pME1xZmhoWG12Rkd1MVdTMkE9PSIsIndlYnNpdGVUeXBlIjoiMSIsIm5iZiI6MTcyMTQxNDk0NSwiZXhwIjoyNTM0MDIzMDA4MDAsImlhdCI6MTcyMTQxNDk0NSwiaXNzIjoiY292ZXJhZ2VmaW5kZXJhcGkubW1pdG5ldHdvcmsuY29tIiwiYXVkIjoiY292ZXJhZ2VmaW5kZXIubW1pdG5ldHdvcmsuY29tICJ9.vQGl3_30Rmd71J5usoyh3wfcY1jH97AJBGRgdBs9I0A">
      </coverage-finder>
    </div>
  );
}

export default App;
